import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import ExploreIcon from '@material-ui/icons/Explore';
import NotificationsIcon from '@material-ui/icons/Notifications';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import CollapseIcon from '@material-ui/icons/KeyboardArrowLeft';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';
import { LinkButton } from '../components';
import {
  LayoutToolsProvider,
  UserProvider,
  LayoutTools
} from '../providers';

const styles: StyleRulesCallback = t => ({
  wrapper: {
    backgroundColor: t.palette.primary.dark,
    display: 'flex',
    flexDirection: 'column'
  },
  menuItem: {
    minWidth: 60,
    color: t.palette.common.white,
    padding: 15
  },
  icon: {
    fontSize: 32
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  avatar: {
    width: 32,
    height: 32,
    backgroundColor: t.palette.primary.dark,
    color: '#FFF',
    fontSize: 14,
    border: '1px solid #FFF'
  }
});

type Props = WithStyles & RouteComponentProps<any>;

type State = {
  activeTab: string;
};

function getNameInitial(name: string | null): string {
  return (name && name.length && name.charAt(0).toUpperCase()) || '?';
}

function getUserInitials(user: User): string {
  const f = getNameInitial(user.firstName);
  const l = getNameInitial(user.lastName);
  return `${f}${l}`;
}

class SideMenu extends React.Component<Props, State> {
  renderAnonymousUserOption() {
    const { classes } = this.props;
    return (
      <Tooltip title="Ingresar" placement="right">
        <LinkButton className={classes.menuItem} to="/signup">
          <AccountCircleIcon className={classes.icon} />
        </LinkButton>
      </Tooltip>
    );
  }

  renderAuthenticatedUserOption(user: User) {
    const { classes } = this.props;
    return (
      <Tooltip title="Mi Cuenta" placement="right">
        <LinkButton className={classes.menuItem} to="/account">
          <Avatar className={classes.avatar}>{getUserInitials(user)}</Avatar>
        </LinkButton>
      </Tooltip>
    );
  }

  renderSearchButton(layout: LayoutTools) {
    const { classes } = this.props;
    return (
      <Tooltip title="Buscar" placement="right">
        <Button
          className={classes.menuItem}
          onClick={() => layout.showBetaDialog()}
        >
          <SearchIcon className={classes.icon} />
        </Button>
      </Tooltip>
    );
  }

  renderNotificationsItem(hasBadge: boolean) {
    const { classes } = this.props;
    return (
      <Tooltip title="Notificaciones" placement="right">
        <LinkButton className={classes.menuItem} to="/notifications">
          {hasBadge ? (
            <Badge badgeContent="1" color="secondary">
              <NotificationsIcon className={classes.icon} />
            </Badge>
          ) : (
            <NotificationsIcon className={classes.icon} />
          )}
        </LinkButton>
      </Tooltip>
    );
  }

  render() {
    const { classes } = this.props;
    const location = this.props.location.pathname;

    if (
      location === '/signup' ||
      location === '/login' ||
      location === '/admin'
    ) {
      return null;
    }

    return (
      <LayoutToolsProvider>
        {layout => (
          <UserProvider>
            {(user: User) => (
              <Paper className={classes.wrapper} square={true}>
                <div className={classes.buttons}>
                  <Tooltip title="Menu" placement="right">
                    <Button
                      className={classes.menuItem}
                      onClick={() => layout.togglePanelOpen()}
                    >
                      {layout.state.panelOpen ? (
                        <CollapseIcon className={classes.icon} />
                      ) : (
                        <MenuIcon className={classes.icon} />
                      )}
                    </Button>
                  </Tooltip>
                  <Tooltip title="Explorar" placement="right">
                    <LinkButton className={classes.menuItem} to="/explore">
                      <ExploreIcon className={classes.icon} />
                    </LinkButton>
                  </Tooltip>
                  {/* {this.renderSearchButton(layout)} */}
                  {this.renderNotificationsItem(layout.state.hasNotifications)}
                </div>
                <div style={{ flex: 0 }}>
                  {user && user.isAnonymous && this.renderAnonymousUserOption()}
                  {user &&
                    !user.isAnonymous &&
                    this.renderAuthenticatedUserOption(user)}
                </div>
              </Paper>
            )}
          </UserProvider>
        )}
      </LayoutToolsProvider>
    );
  }
}

export default withStyles(styles)(withRouter(SideMenu));



// WEBPACK FOOTER //
// ./src/containers/SideMenu.tsx